// src/components/Watermark.tsx
import React, { useEffect } from 'react';
// import Watermark from 'react-watermark';

const WatermarkComponent: React.FC = () => {
  useEffect(() => {
    // 创建水印
    const createWatermark = () => {
      // 创建 canvas 元素
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      // 设置画布大小
      canvas.width = 300;
      canvas.height = 150;

      // 设置文字样式
      ctx.font = '16px Arial';
      ctx.fillStyle = 'rgba(0, 0, 0, 0.1)';
      ctx.rotate(-15 * Math.PI / 180); // 旋转 -15 度

         // 多行文本配置
         const lines = [
          'Diagnosis',
          // '机密文件',
          // 'DO NOT COPY',
          new Date().toLocaleDateString()
        ];
        const lineHeight = 14; // 行间距

        // 绘制多行水印文字
        lines.forEach((line, index) => {
          ctx.fillText(line, 20, 80 + (index * lineHeight));
        });

      // 创建水印容器
      const watermarkDiv = document.createElement('div');
      watermarkDiv.style.position = 'fixed';
      watermarkDiv.style.top = '0';
      watermarkDiv.style.left = '0';
      watermarkDiv.style.width = '100%';
      watermarkDiv.style.height = '100%';
      watermarkDiv.style.zIndex = '9999';
      watermarkDiv.style.pointerEvents = 'none';
      watermarkDiv.style.backgroundImage = `url(${canvas.toDataURL()})`;
      watermarkDiv.style.backgroundRepeat = 'repeat';

      document.body.appendChild(watermarkDiv);

      // 返回清理函数
      return () => {
        document.body.removeChild(watermarkDiv);
      };
    };

    const cleanup = createWatermark();
    return cleanup;
  }, []);

  return null;
};

export default WatermarkComponent;
